import React, { memo, useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { logging, logPostInfo } from '../../../actions/log';

import styles from './DiscountCard.module.less';
import DiscountBtn from '../../DiscountBtn/DiscountBtn';
import useInterval from '../../../utils/hooks/useInterval';
import { setIframeVisible } from '../../../actions/layout';
import { CONTEXT } from '../../../config';
import _LogInView from '../../_LogInView/_LogInView';
import { addClass, changeClass, removeClass } from '../../../utils/utils';
import { getSoftType } from '../../../utils/utils';
import { gameCDKSetVisible } from '../../../actions/gamecdk';
import errorImg from '../../../static/discount/rank_default.png';
import loading from '../../../static/loading.gif';
import DiscountPrice from '../DiscountPrice/DiscountPrice';

let tag = {
  1: '游戏激活码',
  2: '应用会员',
  3: '应用内购买',
  4: '硬件',
};

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
const selectLoginClose = createSelector(
  state => state.user,
  user => user.loginBoxClose,
);

export default memo(({ soft }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const logInfoData = useSelector(selectLogInfo);
  const imgNode = useRef(null);
  const cardNode = useRef(null);
  const [showPrice, setShowPrice] = useState(true);
  const priceNode = useRef(null);
  const userInfo = useSelector(selectUserInfo);
  const [isClickBtn, setIsClickBtn] = useState(false);
  const loginBoxClose = useSelector(selectLoginClose);
  const [showImg, setShowImg] = useState();
  let cTime = useInterval(soft?.discountEndTime);

  useEffect(() => {
    show().then(res => {
      setShowImg(res);
    });
  }, []);

  useEffect(() => {
    if (isClickBtn && loginBoxClose?.result === 0) {
      setIsClickBtn(false);
    }
  }, [loginBoxClose, isClickBtn]);

  useEffect(() => {
    if (userInfo && userInfo?.st && isClickBtn) {
      let gameCdkPrice = 0;
      let gameCdkSid = 0;
      try {
        let priceStr = soft?.currentPrice || soft?.originalPrice;
        gameCdkPrice = parseFloat(priceStr.replace('¥', '').replace('￥', ''));
        gameCdkSid = soft?.sid;
      } catch (error) {}
      dispatch(
        gameCDKSetVisible({
          isShow: true,
          soft: { gameCdkPrice, gameCdkSid },
          source: 'Sales_Rank',
        }),
      );
      setIsClickBtn(false);
    }
  }, [isClickBtn, userInfo]);

  // useEffect(() => {
  //   if (priceNode?.current.clientWidth > 120) {
  //     setShowPrice(false);
  //   } else {
  //     setShowPrice(true);
  //   }
  // }, [priceNode]);

  const handleZk = () => {
    let c = soft?.currentPrice;
    let o = soft?.originalPrice;
    let price = null;
    if (c && o) {
      price = Math.round((c / o) * 10 * 10) / 10;
      return price > 0.1 ? `${price}` : '0.1';
    }
  };

  const handleCard = info => {
    let param3 = {};
    try {
      param3 = JSON.parse(info?.bizInfo);
    } catch (e) {
      param3 = {};
    }
    if (info?.type === 1 || info?.type === 3) {
      dispatch(
        logging({
          category: 'C',
          action: 'handle_SoftCard',
          label: '',
          param2: {
            softType: getSoftType(info?.extInfo?.appInfo),
            softid: info?.extInfo?.appInfo.softID,
            source: 'Sales_Rank',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
          param3: param3,
        }),
      );
    } else {
      let param2 = {
        source: 'Sales_Rank',
        source_p: logInfoData.source_p,
        source_pp: logInfoData.source_pp,
        type: info?.type,
        id: info?.id,
      };

      // 按钮点击打桩
      dispatch(
        logging({
          category: 'C',
          action: 'Sales_Card_Detail',
          label: '',
          param2: param2,
          param3: param3,
        }),
      );
    }
    if ([1, 3].includes(info?.type) && info?.extInfo?.appInfo) {
      dispatch(
        logPostInfo({
          source_p: `Sales_Rank`,
          source_pp: logInfoData.source_p,
        }),
      );
      history.push(
        `${CONTEXT}/detail/soft/${info?.extInfo?.appInfo.softID}/${
          info?.extInfo?.appInfo.bizInfo || '{}'
        }`,
      );
    } else {
      if (info?.extInfo?.sourceType === 1) {
        dispatch(
          setIframeVisible({
            visible: true,
            url: info?.extInfo?.sourceUrl,
            soft,
            source: 'Sales_Rank',
          }),
        );
      } else if (info.extInfo?.sourceType === 2) {
        if (userInfo && userInfo?.st) {
          let gameCdkPrice = 0;
          let gameCdkSid = 0;
          try {
            let priceStr = info?.currentPrice || info?.originalPrice;
            gameCdkPrice = parseFloat(priceStr.replace('¥', '').replace('￥', ''));
            gameCdkSid = info?.extInfo?.sid;
          } catch (error) {}
          dispatch(
            gameCDKSetVisible({
              isShow: true,
              soft: { gameCdkPrice, gameCdkSid },
              source: 'Sales_Rank',
            }),
          );
        } else {
          setIsClickBtn(true);

          window.CallNativeMethod('logout');
          window.CallNativeMethod('login');
        }
      } else {
        window.open(info?.extInfo?.sourceUrl);
      }
    }
  };

  const onMouseOver = e => {
    removeClass(imgNode.current, styles.image_mouse_out);
    addClass(imgNode.current, styles.image_mouse_in);
    removeClass(cardNode.current, styles.card_hover_out);
    addClass(cardNode.current, styles.card_hover_in);
  };

  const onMouseLeave = e => {
    addClass(imgNode.current, styles.image_mouse_out);
    removeClass(imgNode.current, styles.image_mouse_in);
    removeClass(cardNode.current, styles.card_hover_in);
    addClass(cardNode.current, styles.card_hover_out);
  };

  const showCurrentPrice = () => {
    if (soft?.currentPrice === null) {
      return false;
    } else {
      if (soft?.currentPrice === soft?.originalPrice) {
        return false;
      } else {
        return true;
      }
    }
  };

  const show = () => {
    return new Promise((re, rj) => {
      const img = new Image();
      img.onload = () => re(soft?.hImg);
      img.src = loading;
    });
  };

  return (
    <div
      className={styles.discount_card}
      onClick={() => handleCard(soft)}
      onMouseEnter={() => {
        onMouseOver();
      }}
      onMouseLeave={() => {
        onMouseLeave();
      }}
      ref={cardNode}
    >
      <div className="card_left">
        <img
          src={showImg}
          onError={() => {
            setShowImg(errorImg);
          }}
          className="img"
          ref={imgNode}
        />
        <div className="soft_tag">{tag[soft?.type]}</div>
      </div>
      <div className="card_right">
        <div>
          <div className="soft_title" title={soft?.name}>
            {soft?.name}
          </div>
          <div className="soft_desc">{soft?.description}</div>
          {cTime && (
            <div className="countdown">
              <div className="countdown_icon" />
              <div className="conutdown_desc">
                剩余<span className="time">{cTime}</span>结束
              </div>
            </div>
          )}
        </div>
        <DiscountPrice soft={soft} source={'Sales_Rank'} />
        {/* <div className="soft_buy">
          <div className="price" ref={priceNode}>
            {showCurrentPrice() && (
              <div className="zk">
                <span>{handleZk()}</span>
                <span>折</span>
              </div>
            )}

            <div className="n_price">
              <span>¥</span>
              {soft?.currentPrice !== null ? (
                <span>{soft?.currentPrice}</span>
              ) : (
                <span>{soft?.originalPrice}</span>
              )}
            </div>
            {showCurrentPrice() && showPrice && (
              <div className="o_price">¥{soft?.originalPrice}</div>
            )}
          </div>
          <div
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
            }}
          >
            <DiscountBtn
              soft={soft}
              info={{ className: styles.btn, tagClass: styles.btn_tag }}
              logInfo={{ source: 'Sales_Rank' }}
            />
          </div>
        </div> */}
      </div>
      {soft?.orderNum <= 10 && (
        <div className="card_top">
          {soft?.orderNum <= 3 && <span>TOP</span>}
          <span>{soft?.orderNum}</span>
        </div>
      )}
    </div>
  );
});
